import { GridCellParams } from '@mui/x-data-grid-pro';
import { AdGroup } from '@local-types/group';

export const AdGroupIdCellRenderer = (params: GridCellParams<AdGroup>) => {
  return <span>{params.row.temporary ? '-' : params.row.id}</span>;
};
